/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ssoUtil from '../../objects/ssoUtil';
import ko from 'knockout';
import $ from'jquery';


class bootModelModel {

    constructor() {
        // Profile
        this.componentName = ko.observable("boot-Modal");
        this.context = context;
        this.id = ko.observable(this.context.util.guid());

        this.title = ko.observable("Loading....");
        this.displayLogin = ko.observable(false);


        this.username = ko.observable("");
        this.password = ko.observable("");

        this.context.eventManager.subscribe((bootObj) =>{
            console.log("boot-modal:constructor: subscribe: bootObj: %o", bootObj);
            this.updateBootModal(bootObj);
        },this, "show-boot-modal");

        this.init();
    }

    init() {
        $('#bootModal').modal('show');
    }
    
    updateBootModal(bootObj) {

        console.log("Boot Modal");

        if(bootObj == "Login")
        {
            this.title("JDM Login");
            this.displayLogin(true);
        }
        else
        {
            $('#bootModal').modal(bootObj);
        }

    }

    login() {
        let self = this;
        let ssoUtilObj = new ssoUtil(this.context);

        console.log("boot-modal:login:");

        console.log(this.username());

        ssoUtilObj.login({ username: self.username(), password:self.password() }).then( response => {
            console.log("boot-modal:login: %o", response);
        });
    }

}

export default { viewModel: bootModelModel, template: require('!raw-loader!./boot-modal.html') };


// WEBPACK FOOTER //
// ./src/components/boot-modal/boot-modal.js